const initFilters = () => {
  const filter = document.querySelector('.catalog-filter');
  const fakeFilter = document.createElement('div');
  const filterDropdown = document.querySelector('[data-drop-filter]');
  const filterInput = document.getElementById('js-live-filter');
  const FILTER_CLASSES = {
    filterWrapper: 'catalog-filter__search',
    filterFixed: 'is-fixed',
    dropOpened: 'is-opened',
    elHidden: 'is-hidden',
    searchOpen: 'is-open',
  };


  if (filter) {
    const filterParent = filter.parentNode;

    document.body.classList.add('has-filter');
    fakeFilter.classList.add('fake-filter');
    setFilterHeight(filter, fakeFilter);
    filterParent.insertBefore(fakeFilter, filter.nextSibling);

    window.addEventListener('scroll', () => {
      const filterParentPadd = parseInt(
          window.getComputedStyle(filterParent, null).getPropertyValue('padding-top'), 10
      );

      if (filterParentPadd + filterParent.getBoundingClientRect().top <= 0) {
        filter.classList.add(FILTER_CLASSES.filterFixed);
      } else {
        filter.classList.remove(FILTER_CLASSES.filterFixed);
      }

      // console.log(window.pageYOffset);

      if (filterDropdown.classList.contains(FILTER_CLASSES.dropOpened)) {
        // filterDropdown.click();
      }
    });
  }


  if (filterDropdown) {
    filterDropdown.addEventListener('click', () => {
      const parentFilter = filterDropdown.closest('.catalog-filter');
      const targetSelector = filterDropdown.dataset.dropFilter;
      const targetEl = document.querySelector(targetSelector);

      filterDropdown.classList.toggle(FILTER_CLASSES.dropOpened);

      if (targetEl) {
        targetEl.classList.toggle(FILTER_CLASSES.dropOpened);
      }

      if (parentFilter) {
        parentFilter.classList.toggle(FILTER_CLASSES.dropOpened);
      }

      // Recalc height
      setFilterHeight(filter, fakeFilter);
    });
  }


  // FILTER ITEMS
  if (filterInput) {
    const filteredItems = document.querySelectorAll('[data-test-filter]');
    const searchWrapperEl = filterInput.closest('.' + FILTER_CLASSES.filterWrapper);

    filterInput.addEventListener('keyup', (e) => {
      liveSearch(e.currentTarget, filteredItems);
    });

    // Mobile opener
    if (!searchWrapperEl) {
      return;
    }

    searchWrapperEl.addEventListener('click', (e) => {
      const currentWidth = document.documentElement.clientWidth || window.innerWidth;
      if (currentWidth > 767) {
        return;
      }

      e.currentTarget.classList.add(FILTER_CLASSES.searchOpen);
      window.addEventListener('click', (event) => onClickOutside(event, searchWrapperEl));
    });
  }

  const onClickOutside = (e, wrapper) => {
    if (!e.target.className.includes(FILTER_CLASSES.filterWrapper)) {
      wrapper.classList.remove(FILTER_CLASSES.searchOpen);
    }
  };

  // Functions
  function liveSearch(target, items) {
    const searchQuery = target.value.toLowerCase();

    for (let i = 0; i < items.length; i++) {
      const itemContent = items[i].querySelector('[data-content]');

      if (!itemContent) {
        return;
      }

      const itemText = itemContent.textContent || itemContent.innerText;

      if (itemText.toLowerCase().includes(searchQuery)) {
        items[i].classList.remove(FILTER_CLASSES.elHidden);
      } else {
        items[i].classList.add(FILTER_CLASSES.elHidden);
      }
    }
  }

  function setFilterHeight(realBlock, fakeBlock) {
    fakeBlock.style.height = realBlock.offsetHeight ? realBlock.offsetHeight + 'px' : null;
  }
};

export {initFilters};

